import React from 'react';
import tw, { styled } from 'twin.macro';
import { motion } from 'framer-motion';
import { Container as ContainerBase, Content2Xl } from "components/misc/Layouts.js";
import { Subheading, SectionHeadingH2 } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

const Container = styled(ContainerBase)`
  //background-color: #f8f9fa;
  padding-top: 8rem;
  padding-bottom: 1rem;
`;

const Heading = styled(SectionHeadingH2)`
  width: 100%;
  text-align: left;
  color: #333;
  margin-bottom: 2rem;
`;

const SubHeading = styled(Subheading)`
  text-align: center;
  margin-bottom: 1rem;
  color: #4a90e2;
`;

const Description = styled(SectionDescription)`
  margin-top: 1rem;
  min-width: 100%;
  color: #666;
  font-size: 1rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 3rem;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  width: 100%;
  margin-bottom: 8rem;
`;

const ResourceCard = styled(motion.div)`
  background: linear-gradient(135deg, #f0f2f5 0%, #e2e6ed 100%);
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 280px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.18);
`;

const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.75rem;
`;

const CardDescription = styled.p`
  font-size: 0.875rem;
  color: #555;
  flex-grow: 1;
`;

const ReadMoreLink = styled.a`
  align-self: flex-end;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #4a90e2;
  color: white;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  text-decoration: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3a7bc8;
  }
`;

const DeveloperResources = ({ content }) => {
  const { heading, subheading, description, resources } = content;

  return (
    <Container>
      <Content2Xl>
        <SubHeading>{subheading}</SubHeading>
        <Heading>{heading}</Heading>
        <Description>{description}</Description>
        <CardGrid>
          {resources.map((resource, index) => (
            <ResourceCard
              key={index}
              whileHover={{ y: -5, boxShadow: '0 10px 30px -15px rgba(0, 0, 0, 0.2)' }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <div>
                <CardTitle>{resource.title}</CardTitle>
                <CardDescription>{resource.description}</CardDescription>
              </div>
              <ReadMoreLink href={resource.link} target="_blank" rel="noopener noreferrer">
                {resource.linkText}
              </ReadMoreLink>
            </ResourceCard>
          ))}
        </CardGrid>
      </Content2Xl>
    </Container>
  );
};

export default DeveloperResources;
